// extracted by mini-css-extract-plugin
export var surveySessionColumnItem = "survey-session-column-item-module--survey-session-column-item--gRA-4";